export default __webpack_public_path__ + "static/media/EcommerceServicesLebenswerkBusinessManagement9.2a48ccca.png";